import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Navbar from '../Navbar/Navbar';
import { useTheme } from '../ThemeContext';
import './Profile.css';
import avatarImage from '../Profile/avatar.png';

const Profile = () => {
  const { user } = useAuth();
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [userId, setUserId] = useState('');
  const [organizationName, setOrganizationName] = useState('');
  const { theme } = useTheme();
  useEffect(() => {
    if (user) {
      setEmail(user.email);
      setDisplayName(user.displayName);
      setRole(user.role);
      setUserId(user.id);
      setOrganizationName(user.organizationName || user.organization || '');
    }
  }, [user]);

  return (
    <div className={`Profile-container ${theme}`}>
      <Navbar />
      <div className="Profile-content page-transition">
        <div className="page-shell profile-card">
          <div className="profile-title-row">
            <h1 className="page-title">Profile</h1>
          </div>
          <div className="profile-header">
            <div className="avatar-container">
              <img src={avatarImage} alt="Avatar" />
            </div>
            <div className="profile-summary">
              <h2 className="profile-name">{displayName || 'Loading name...'}</h2>
              <p className="profile-email">{email || 'Loading email...'}</p>
              <span className="profile-role">{role || 'Loading role...'}</span>
            </div>
          </div>
          <div className="profile-details">
            <div className="detail-row">
              <span className="detail-label">Auth Type</span>
              <span className="detail-value">Email/Password</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">User ID</span>
              <span className="detail-value">{userId || 'Loading ID...'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Organization</span>
              <span className="detail-value">{organizationName || 'default'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
